type TruckChipColorConfig = {
  bg: string;
  text: string;
  variant: "solid" | "outlinedLight" | "outlinedDark";
};

const truckChipColorConfigs: TruckChipColorConfig[] = [
  // Blue shades
  { bg: "#2196F3", text: "#FFFFFF", variant: "solid" },
  { bg: "#1976D2", text: "#FFFFFF", variant: "solid" },
  { bg: "#42A5F5", text: "#FFFFFF", variant: "solid" },
  { bg: "#0D47A1", text: "#FFFFFF", variant: "solid" },
  { bg: "#1565C0", text: "#FFFFFF", variant: "solid" },
  { bg: "#64B5F6", text: "#000000", variant: "solid" },
  { bg: "#0277BD", text: "#FFFFFF", variant: "solid" },
  { bg: "#0288D1", text: "#FFFFFF", variant: "solid" },
  // Green shades
  { bg: "#4CAF50", text: "#FFFFFF", variant: "solid" },
  { bg: "#388E3C", text: "#FFFFFF", variant: "solid" },
  { bg: "#66BB6A", text: "#FFFFFF", variant: "solid" },
  { bg: "#1B5E20", text: "#FFFFFF", variant: "solid" },
  { bg: "#2E7D32", text: "#FFFFFF", variant: "solid" },
  { bg: "#81C784", text: "#000000", variant: "solid" },
  { bg: "#43A047", text: "#FFFFFF", variant: "solid" },
  { bg: "#558B2F", text: "#FFFFFF", variant: "solid" },
  // Red/orange shades
  { bg: "#F44336", text: "#FFFFFF", variant: "solid" },
  { bg: "#D32F2F", text: "#FFFFFF", variant: "solid" },
  { bg: "#FF5722", text: "#FFFFFF", variant: "solid" },
  { bg: "#E64A19", text: "#FFFFFF", variant: "solid" },
  { bg: "#C62828", text: "#FFFFFF", variant: "solid" },
  { bg: "#EF5350", text: "#FFFFFF", variant: "solid" },
  { bg: "#FF7043", text: "#FFFFFF", variant: "solid" },
  { bg: "#FF6F00", text: "#FFFFFF", variant: "solid" },
  // Purple shades
  { bg: "#9C27B0", text: "#FFFFFF", variant: "solid" },
  { bg: "#7B1FA2", text: "#FFFFFF", variant: "solid" },
  { bg: "#BA68C8", text: "#FFFFFF", variant: "solid" },
  { bg: "#4A148C", text: "#FFFFFF", variant: "solid" },
  { bg: "#6A1B9A", text: "#FFFFFF", variant: "solid" },
  { bg: "#CE93D8", text: "#000000", variant: "solid" },
  { bg: "#AB47BC", text: "#FFFFFF", variant: "solid" },
  { bg: "#8E24AA", text: "#FFFFFF", variant: "solid" },
  // Yellow/amber, teal/cyan, pink, and neutral shades
  { bg: "#FFC107", text: "#000000", variant: "solid" },
  { bg: "#FFA000", text: "#FFFFFF", variant: "solid" },
  { bg: "#FFD54F", text: "#000000", variant: "solid" },
  { bg: "#F9A825", text: "#000000", variant: "solid" },
  { bg: "#009688", text: "#FFFFFF", variant: "solid" },
  { bg: "#00796B", text: "#FFFFFF", variant: "solid" },
  { bg: "#26A69A", text: "#FFFFFF", variant: "solid" },
  { bg: "#00ACC1", text: "#FFFFFF", variant: "solid" },
  { bg: "#E91E63", text: "#FFFFFF", variant: "solid" },
  { bg: "#C2185B", text: "#FFFFFF", variant: "solid" },
  { bg: "#EC407A", text: "#FFFFFF", variant: "solid" },
  { bg: "#AD1457", text: "#FFFFFF", variant: "solid" },
  { bg: "#795548", text: "#FFFFFF", variant: "solid" },
  { bg: "#607D8B", text: "#FFFFFF", variant: "solid" },
  { bg: "#5C6BC0", text: "#FFFFFF", variant: "solid" },
  { bg: "#3F51B5", text: "#FFFFFF", variant: "solid" },
].flatMap<TruckChipColorConfig>((color, index) => [
  { ...color, variant: "solid" },
  {
    ...color,
    variant: index % 2 === 0 ? "outlinedLight" : "outlinedDark",
  },
]);

export const getLogislyOrderTakerV2TruckChipStyle = (truckKey: string) => {
  let hash = 5381;
  const normalizedTruckKey = truckKey.toLowerCase().trim();
  for (let index = 0; index < normalizedTruckKey.length; index += 1) {
    hash = (hash << 5) + hash + normalizedTruckKey.charCodeAt(index);
  }
  const color = truckChipColorConfigs[Math.abs(hash) % truckChipColorConfigs.length];
  const isOutlined = color.variant !== "solid";

  return {
    backgroundColor: isOutlined
      ? color.variant === "outlinedLight"
        ? "#FFFFFF"
        : "#000000"
      : color.bg,
    backgroundImage: "none",
    border: "2px solid",
    borderColor: color.bg,
    color: isOutlined ? (color.variant === "outlinedLight" ? "#000000" : "#FFFFFF") : color.text,
  };
};
